import React from 'react';
import {Chip, Typography} from "@material-ui/core";
import {RESOURCES_TYPES} from "./Source/Materias";
import VideoPlayer from "react-simple-video-player";
import Link from "@material-ui/core/Link";
import {makeStyles} from "@material-ui/core/styles";
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import Button from "@material-ui/core/Button";
import {YouTube} from "@material-ui/icons";

export const RESOURCES_BASEPATH = "http://uvt-public-assets.s3-accelerate.amazonaws.com";

const useStyles = makeStyles((theme) => ({
    section: {
        padding: '20px 0'
    },
    pills: {
        padding: '0 10px'
    }
}));

export default function Factory(props) {
    const classes = useStyles();

    function External({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Material de Apoyo Externo: {component.title}
                </Typography>
                <Link href={`${RESOURCES_BASEPATH}${component.url}`} target="_blank">
                    Ir al material de apoyo (link externo)
                </Link>
            </div>
        );
    }

    function Exam({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Examen de Módulo
                    <span className={classes.pills}>
                        <Chip
                            icon={<QueryBuilderIcon/>}
                            label={`Fecha de entrega: ${component.dueDate}`}
                            color="secondary"
                        />
                    </span>
                </Typography>
                <Typography>
                    Para acreditar el módulo, deberás completar este examen de opción múltiple. Una vez comenzado, no podrás regresar después.
                </Typography>
                <Link href="/exam/123" target="_blank">
                    Comenzar examen
                </Link>
            </div>
        )
    }

    function Youtube({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Material de Apoyo (YouTube): {component.title}
                </Typography>
                <Link href={component.url} target="_blank">
                    Ir a liga de YouTube (link externo)
                </Link>
            </div>
        );
    }

    function Video({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Video: {component.title}
                </Typography>
                <VideoPlayer
                    url={`${RESOURCES_BASEPATH}${component.url}`}
                    poster={`${RESOURCES_BASEPATH}/LogoAdmin.jpeg`}
                />
            </div>
        );
    }

    function Rubrica({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    {component.title}
                </Typography>
                <Link href={`${RESOURCES_BASEPATH}${component.url}`} target="_blank">
                    Descargar rúbricas de evaluación
                </Link>
            </div>
        );
    }

    function Apoyo({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Material de Apoyo: {component.title}
                </Typography>
                <Link href={`${RESOURCES_BASEPATH}${component.url}`} target="_blank">
                    Descargar Material de Apoyo
                </Link>
            </div>
        );
    }

    function Ejercicios({component}) {
        return (
            <div className={classes.section}>
                <Typography variant="h5">
                    Ejercicios del tema: {component.title}
                    <span className={classes.pills}>
                        <Chip
                            icon={<QueryBuilderIcon/>}
                            label={`Fecha de entrega: ${component.dueDate}`}
                            color="secondary"
                        />
                    </span>
                </Typography>
                <Link href={`${RESOURCES_BASEPATH}${component.url}`} target="_blank">
                    Descargar Ejercicios del Tema
                </Link>
                <div className={classes.section}>
                    <Typography variant="h6">
                        Entrega de Actividades
                    </Typography>
                    <Typography>
                        <div className={classes.section}>
                            <input type="file" name="file" />
                        </div>
                        <Button variant="contained" color="primary">
                            Subir Archivo
                        </Button>
                    </Typography>
                </div>
            </div>
        );

    }

    switch (props.component.type) {
        case RESOURCES_TYPES.APOYO:
            return <Apoyo component={props.component}/>;
        case RESOURCES_TYPES.EJERCICIOS:
            return <Ejercicios component={props.component}/>
        case RESOURCES_TYPES.RUBRICA:
            return <Rubrica component={props.component}/>;
        case RESOURCES_TYPES.VIDEO:
            return <Video component={props.component}/>;
        case RESOURCES_TYPES.EXTERNAL_LINK:
            return <External component={props.component}/>
        case RESOURCES_TYPES.YOUTUBE:
            return <Youtube component={props.component}/>
        case RESOURCES_TYPES.EXAM:
            return <Exam component={props.component}/>
        default:
            return <></>
    }
}

